import React, { VFC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {
  count: number
  className?: string
}

export const ProjectCountTxt: VFC<Props> = ({ count, className }) => {
  return (
    <Txt
      sizeType="s"
      className={`${count === 0 ? 'tw-text-standardText-disable' : ''} ${className}`}
    >
      {count}
    </Txt>
  )
}
